import React from 'react';
import {observer} from 'mobx-react';
import {EPOverlay} from './ep-overlay';
import {UVOverlay} from './uv-overlay';
import {ProductCustomizationState} from './render.def';
// IMPORTANT: MUST NOT import from s.ts (product store) - this renderer code is used in multiple apps for image rendering

declare var __image_gen: boolean;
declare var __product_page: boolean;

type Props = {
    pcs: ProductCustomizationState;
};

// Renders CustomizationMethodID = 0
export const FrameNone = observer(({pcs}: Props) => {
    return (
        <div id="frame-none-container">
            <div id="frame-none-container-inner">
                {/* The wrapper shrink-wraps the displayed image so EPOverlay's percentage
                    coords resolve against the photo itself, not the full-width flex box.
                    The img's stylesheet 90% cap moves onto the wrapper (maxWidth 90%) with
                    the img filling it (maxWidth 100%) - same displayed size as before.
                    isolation keeps the overlays' z-indexes local to this stack: without
                    it EPOverlay/UVOverlay (z5) join the page's root stacking context,
                    tie the header's open nav menus (.nav-expanded, also z5) and, being
                    later in the DOM, paint the plate through the open menu. */}
                <div
                    id="frame-none-wrapper"
                    style={{position: 'relative', display: 'inline-block', maxWidth: '90%', isolation: 'isolate'}}
                >
                    <img
                        id="frame-none"
                        className="img-core"
                        // display block: without Bootstrap's img reset (imagegen's stack2 page)
                        // an inline img leaves a baseline gap that would skew the overlay's
                        // percentage coords against the wrapper.
                        style={{maxWidth: '100%', display: 'block'}}
                        src={`https://${pcs.CDNDomain}/images/products/full/${pcs.Image_Full.toLowerCase()}`}
                        alt={`Product Image of ${pcs.ProductName_Original}`}
                    />
                    <EPOverlay pcs={pcs} />
                    <EPOverlay
                        pcs={pcs}
                        plate={2}
                    />
                    <UVOverlay pcs={pcs} />
                </div>

                {pcs.ProductTypeID === 5 && !__image_gen && __product_page && (
                    <div className="tassel-cord tassel-cord-0">
                        <picture>
                            <source
                                type="image/webp"
                                srcSet={`https://${pcs.CDNDomain}/images/cached/general/honor-cord1.webp`}
                            />
                            <img
                                width="128"
                                height="128"
                                src={`https://${pcs.CDNDomain}/images/cached/general/honor-cord1.png`}
                                alt="Frame Also Holds Cord"
                                loading="lazy"
                            />
                        </picture>
                    </div>
                )}
            </div>
        </div>
    );
});
